/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// MODULES //

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';


// MAIN //

/**
* Component for navigating to package documentation.
*
* @private
* @param {Object} props - component properties
* @param {string} props.pkg - package name (e.g., `math/base/special/sin`)
* @param {string} props.path - package documentation URL
* @returns {ReactElement} React element
*/
function Docs( props ) {
	return (
		<li key="documentation" className="top-nav-item" role="menuitem">
			<Link to={ props.path } title="View package documentation">documentation</Link>
		</li>
	);
}

/**
* Component property types.
*
* @constant
* @name propTypes
* @memberof Docs
* @type {Object}
*/
Docs.propTypes = {
	'pkg': PropTypes.string.isRequired,
	'path': PropTypes.string.isRequired
};


// EXPORTS //

export default Docs;
